import React from "react";

const CTA = () => {
  return (
    <div className="cta">
      <div className="cta-left">
        <h3 className="cta-title">Let’s try our service now!</h3>
        <p className="cta-info">
          Everything you need to accept card payments and grow your business
          anywhere on the planet.
        </p>
      </div>
      <div className="cta-right">
        <a className="business-btn">Get Started</a>
      </div>
    </div>
  );
};

export default CTA;
